import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SUPPORT_FLAGS, parseSupportFlags } from 'constants/support-flags';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { IconButton } from 'components/IconButton/IconButton';

export const ActionRequiredButtons = ({ flags, onToggle, small = false, className = '' }) => {
  const active = parseSupportFlags(flags);

  return (
    <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
      {SUPPORT_FLAGS.map(({ slug, label, icon }) => (
        <IconButton
          key={slug}
          prefix="fa"
          icon={icon}
          tip={label}
          small={small}
          active={active.includes(slug)}
          onClick={() => onToggle(slug)}
        />
      ))}
    </div>
  );
};

export const ActionRequiredIcons = ({ flags, className = '' }) => {
  const active = parseSupportFlags(flags);
  if (!active.length) return null;

  return (
    <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
      {SUPPORT_FLAGS.filter(({ slug }) => active.includes(slug)).map(({ slug, label, icon }) => (
        <OverlayTrigger key={slug} placement="top" overlay={<Tooltip>{label}</Tooltip>}>
          <span className="d-inline-flex align-items-center justify-content-center secondary-text p-1">
            <FontAwesomeIcon icon={icon} />
          </span>
        </OverlayTrigger>
      ))}
    </div>
  );
};
